export const getRolesFromItem = (item: any, isFromKontent: boolean) => {
  if (!item || !item.roles) {
    return null;
  }
  if ('roles' in item && Array.isArray(item.roles)) {
    if (!isFromKontent) {
      return (item.roles as string[]).map(r => r.toLowerCase());
    }
    return extractRolesNameFromItem(item.roles);
  }

  return [];
};

export const extractRolesNameFromItem = (roles: any) => {
  return Array.isArray(roles)
    ? roles.map((r: { name: string }) => r.name.toLowerCase())
    : [];
};
